export const isYoutubeUrl = (url: string) => {
  return url.includes('youtu.be') || url.includes('youtube.com');
};

export const isGifUrl = (url: string) => {
  return url.includes('.gif');
};

export const isVimeoUrl = (url: string) => {
  return url.includes('vimeo.com');
};
